function SidebarHeading({ children }) {
  return (
    <div className="flex h-16 flex-shrink-0 items-center justify-center border-gray-200 bg-primary-900 px-1 dark:border-b dark:border-gray-700 dark:bg-gray-800">
      {children}
    </div>
  );
}

export default SidebarHeading;
